import { getplatlists, getptnlists, getshoplists, gettradefrom } from '@/common/mixins/select'
import handleExport from '@/common/mixins/handle-export'
import { actionLineWithoutImport, actionLineWithImport } from '@/common/js/desc.js'
import ImportDialog from '@/base/importDialog'
import ExportDialog from '@/base/exportDialog'
import { module_api } from '@/common/config.js'
import { dealReturn } from '@/common/js/index.js'

// 上面这个import 这个文件虽然用不上，别的地方需要
// 因为所有页面都引用了 这个mixin, 所以从这里注入一些 所有页面都需要的变量或组件

// 即使以功能或命名 拆分mixin,也不是好的方法，
// 将页面拆分成三个组件 优于mixin
export default {
	mixins: [ getplatlists, getptnlists, getshoplists, gettradefrom, handleExport ],
	components: {
		ImportDialog,
		ExportDialog
	},
	data () {
		return {
			form: {
				business: '', // 商家
				store: '' // 店铺
			},
			searchAreaStatus: false, // 搜索区域开关状态
			queryPrdlists: {
				param: {},
				query: {},
				pagenum: 1,
				pagesize: 20,
				reportname: null // 当前“模块” 路由
			},
			total: 0,
			actionLineWithoutImport: actionLineWithoutImport,
			actionLineWithImport: actionLineWithImport,
			loading: false,
			tableData: [],
			currentModule: {}, // 报存当前模块下的接口信息
			moduleName: ''
		}
	},
	computed: {
		pageNumOrPageSizeChange: function () {
			return this.queryPrdlists.pagenum + '-' + this.queryPrdlists.pagesize
		}
	},
	created () {
		this.getCurrentModuleApi()
		this.queryPrdlists.reportname = this.$route.fullPath.replace('/', '')
		// console.log("this.$route", this.$route.fullPath.replace('/', ''))
		this.getTableData()
	},
	methods: {
		// 具体文件下的desc.js 中定义url 优先级高于 @/common/config.js 中定义url
		getCurrentModuleApi () {
			let moduleName = this.$route.meta.routeName.split('.')[0]
			this.currentModule = module_api[moduleName]
			this.moduleName = moduleName
		},
		async getTableData () {
			let list_api = this.Desc.list_api ? this.Desc.list_api : this.currentModule.list
			console.log('this.Desc', this.Desc)
			console.log('this.$route.routeName:', this.$route)
			if (this.$route.meta.routeName.split('.')[0] === 'promote') {
				// promoteDataList 推广下的页面的 列表， 参数是url 字段名 reportname
				this.queryPrdlists.reportname = this.$route.path.replace('/', '')
			}
			this.loading = true
			let { data, err } = await this.axiosApi(list_api, this.queryPrdlists)

			this.loading = false
			if (data && data.data && data.data.meta.status === 200) {
				this.tableData = data.data.data.data
				this.total = parseInt(data.data.data.total)
			} else {
				dealReturn(data, err)
			}
		},
		// action-line 组件的事件
		handleActionLine (handler) {
			this[handler] && this[handler]()
		},
		//

		// 导入相关的两个函数
		// 卖家网导入 不校验导入文件
		async handleImport () {
			// debugger;
			// 获取导入文件信息
			// fileHeader_api
			// 推广下的导入文件头信息获取url：// 导入文件头信息 接口 get  /excelheaderTuiguang/{reportname} 路由url拼接
			// debugger;
			// let url = this.$route.meta.routeName.split('.')[1]
			let url = this.$route.fullPath.replace('/', '')
			// 目前4.16 只有推广在 '@/common/config.js' 有配置 有this.currentModule
			// debugger;
			let api =
				this.currentModule && this.currentModule.fileHeader
					? this.currentModule.fileHeader
					: this.Desc.fileHeader_api
			if (this.currentModule && this.currentModule.fileHeader) {
				// 推广是 拼接url
				var { data, err } = await this.axiosApi({
					url: api.url + '/' + url,
					method: this.currentModule.fileHeader.method
				})
			} else {
				// 其他页面 是独立的url
				var { data, err } = await this.axiosApi(api)
			}
			if (data && data.data.meta.status === 200) {
				this.$refs.refImportDialog.show(data.data.data)
			} else {
				this.$message.error('获取导入文件头信息失败')
				// this.$refs.refImportDialog.show([]);
			}
		},
		// 导入
		async handleFile (form) {
			// debugger;

			let formData = new FormData()
			for (let key in form) {
				formData.set(key, form[key])
			}
			// 各个页面的上传url 定义在 desc.js 的 upload_api 中
			// 现在有一个需求，推广下的所有页面使用同一个url promoteDataUpload
			// 为了不去一个个文件里写，在这里统一手动赋值
			// 有路由层级的数据的菜单 在sessionStorage menulist
			let upload_api = this.Desc.upload_api ? this.Desc.upload_api : this.currentModule.upload
			// if (this.$route.path)
			console.log('this.$route.path', this.$route.path)
			let { data, err } = await this.axiosApi(upload_api, formData)
			console.log(data)
			if (data && data.status === 200) {
				let type = (data.data && (data.data.data.result || data.data.data.indexOf('未完成') == -1)) ? 'success' : 'error'
				this.$message({
					type: type,
					message: (data.data && data.data.data) ? data.data.data : ''
					// offset: 61
				})
			} else {
				dealReturn(data, err)
			}
		},

		// 导出
		handleExport () {
			this.$refs.refExportDialog.show()
		},
		async exportSubmit (form) {
			// debugger;
			console.log('this. exportSubmit', form)
			if (!this._collectQuery()) {
				return
			}
			Object.assign(form, this.queryPrdlists)
			console.log('complieForm', form)

			this.$refs.refExportDialog.hide()
			this.$refs.refExportDialog.turnLoading(true)
			let export_api = this.Desc.export_api ? this.Desc.export_api : this.currentModule.export
			let { data, err } = await this.axiosApi(export_api, form)
			console.log(data)
			if (data && data.status === 200) {
				let type = (data.data && data.data.data.result) ? 'success' : 'error'
				this.$message({
					type: type,
					// message: '下载导出文件，请访问 “操作历史” 页'
					message: (data.data && data.data.data.message) ? data.data.data.message : ''
					// offset: 61
				})
			} else {
				dealReturn(data, err)
			}
			console.log(err)
			this.$refs.refExportDialog.turnLoading(false)
			// 根据返回判断是否关闭 弹窗
			// 后端不会任何返回 直接提示
			// 直接关闭弹窗 不等请求的返回结果
		},

		handleSizeChange (val) {
			this.queryPrdlists.pagesize = val
		},
		handleCurrentChange (val) {
			this.queryPrdlists.pagenum = val
		},
		handleSearch () {
			// console.log("this.$refs", this.$refs)
			// 检测 数组字段 判断 两个数字的大小
			// if (this.form.payment) this.form.payment = [this.form.paymentLower, this.form.paymentUpper];
			if (!this._collectQuery()) {
				return
			}
			console.log('this.queryPrdlists', this.queryPrdlists)
			this.getTableData()
		},
		clearSearch () {
			this.form = {
				business: '', // 商家
				store: '' // 店铺
			}
			if (this.platCode) this.platCode = '' // 像这样的 与页面强相关的东西，放到哪里可以考虑下
			console.log('clearSearch this.form', this.form)
			this.handleSearch()
		},
		_collectQuery () {
			// 给初始化时，调用getTableData() 之前收集搜索字段
			// debugger
			// 检测数值范围  NumberRange 组件里的值
			let isValid = true
			for (let item in this.form) {
				if (Array.isArray(this.form[item])) {
					// debugger;
					// if (this.form[item].length === 2 && this.form[item][0] === "" && this.form[item][1] === "") {
					//   delete this.form[item]
					//   isValid = true;
					// }
					if (
						!(this.form[item].length === 2 && this.form[item][0] === '' && this.form[item][1] === '') &&
						!(this.form[item].length === 1 && this.form[item][0] === '') &&
						!(this.form[item].length === 1 && this.form[item][1] === '')
					) {
						if (
							this.form[item].length === 1 ||
							(this.form[item].length === 2 && !this.form[item][0] && this.form[item][0] !== 0) ||
							(this.form[item].length === 2 && !this.form[item][1] && this.form[item][1] !== 0)
						) {
							this.$message.error('请填写完整“范围”')
							isValid = false
						} else if (this.form[item] && this.form[item].length !== 0) {
							if (this.form[item][0] > this.form[item][1]) {
								this.$message.error('左侧为下限，右侧为上限，上限需要大于下限')
								isValid = false
							}
						}
					}
				}
			}

			this.queryPrdlists.param = Object.keys(this.form)
			this.queryPrdlists.query = JSON.parse(JSON.stringify(this.form))

			// 月报的日期没有日 ["2021-01", "2021-03"] 自动添加 01 --> ["2021-01-01", "2021-03-01"]
			// 字段名都是 create_time
			// 为了不影响 this.form的值 直接在 this.queryPrdlists.query上修改
			// debugger;
			let list,
				arr = []
			if (this.form.create_time && this.form.create_time[0]) {
				list = this.form.create_time[0].split('-')
				if (list.length === 2) {
					this.form.create_time.forEach((item) => {
						arr.push(item + '-01')
					})
					this.queryPrdlists.query.create_time = arr
				}
			}
			return isValid
		}
		// _checkAllNumberRange() {

		// }
	},
	watch: {
		pageNumOrPageSizeChange (newVal, oldVal) {
			if (this.searchAreaStatus) {
				this.searchAreaStatus = false // xx
			}
			this.getTableData()
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/mixins/search-mixin/index.js